import "./views.scss";

import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";

import NeedMoreHelp from "../components/buttons/NeedMoreHelp";
import { useFormFlowContext } from "../components/forms/FormFlowContext";
import LoadingBeacon from "../components/loading/LoadingBeacon";
import { CircleCheck } from "../components/svgs/circle-check";
import useSendAuthLinkError from "../helpers/hooks/useSendAuthLinkError";
import { triggerCommunityRegistrationView } from "../helpers/observability/analytics";
import { sendAuthLink } from "../services/requests";
import appSettings from "../settings/appSettings";

const OneTimeLogin = () => {
  const { auth0OnlyExperience, bothAccountsExperience, userData } = useFormFlowContext();
  const { successRedirectUrl } = appSettings;
  const [resendingEmail, setResendingEmail] = useState(false);
  const [resendingComplete, setResendingComplete] = useState(false);
  const { onSendAuthLinkError } = useSendAuthLinkError();

  const ResendEmailButton = () => {
    if (!resendingEmail && !resendingComplete) {
      return (
        <button
          className="link btn-text-blue base navigate p-0 text-align-start width-fit"
          onClick={() => handleResendClick("resend")}>
          <strong>Resend one-time login email.</strong>
        </button>
      );
    }

    return (
      <div className="display-flex align-center">
        <button
          className="link btn-text-blue base navigate p-0 text-align-start width-fit"
          onClick={() => handleResendClick()}
          disabled={resendingEmail}>
          <strong>
            {resendingComplete ? (
              <>One-time login email resent!</>
            ) : (
              <>Resending one-time login email...</>
            )}
          </strong>
        </button>
        {resendingComplete ? (
          <span className="display-flex">
            <CircleCheck inline />
          </span>
        ) : (
          <LoadingBeacon inline />
        )}
      </div>
    );
  };

  useEffect(() => {
    if (resendingComplete) {
      setResendingEmail(false);
    }
  }, [resendingComplete]);

  const sendAnalyticsOnetimeLogin = (label = "send_one-time_login_email") => {
    triggerCommunityRegistrationView({
      "event_action": "send_one-time_login_email",
      "event_label": label,
    });
  }

  const handleResendClick = async (label) => {
    if (!userData?.email) {
      return;
    }

    setResendingComplete(false);
    setResendingEmail(true);
    sendAnalyticsOnetimeLogin(label);

    await sendAuthLink(userData.email)
      .then(() => setResendingComplete(true))
      .catch(onSendAuthLinkError("Error resending one-time login email", "one_time_login"));
  };

  return (
    <div className="views display-grid gap-xl">
      <div className="display-flex justify-center">
        <CircleCheck />
      </div>
      <div>
        <h1 className="serif width-100 display-flex justify-center mb-base">
          <strong>One-time Login</strong>
        </h1>
        <p className="base">
          Please check your email for a message from World Vision containing a one-time login link.
        </p>

        <p className="base">
          <b>Important: </b> The login link will expire in 24 hours.
        </p>
      </div>

      <div className="display-grid gap-tight mt-base mb-base">
        {(auth0OnlyExperience || bothAccountsExperience) && (
          <button className="btn-text-blue base navigate p-0 text-align-start width-fit">
            <a href={successRedirectUrl} target="_blank" onClick={() => sendAnalyticsOnetimeLogin("manual_sign_in")}>
              <strong>Click here to sign in manually</strong>{" "}
              <FontAwesomeIcon icon={faArrowRight} />
            </a>
          </button>
        )}
        <ResendEmailButton />
        <NeedMoreHelp from="one_time_login" />
      </div>
    </div>
  );
};

export default OneTimeLogin;
